import type {ComputationResult} from './../computation-result';
import type {Computation} from './../computation';
import type {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.TTest1Samp
 */
export interface TTest1Samp extends Computation._UnivariateComputation {
    hypothesizedMean: number;

    // PolyJson type
    type: 'ttest_1samp';
}

export namespace TTest1Samp {
    export const type = 'ttest_1samp';
}

/** @deprecated Use Computation.isTTest1Samp() */ export function isTTest1Samp(toTest: Computation): toTest is TTest1Samp { return TTest1Samp.type === toTest['type']; }

export namespace TTest1Samp {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TTest1Samp$TTest1SampResult
     */
    export interface TTest1SampResult extends _AvailableResult {
        dof: number;
        pvalue: number;
        pvalueAltGt: number;
        pvalueAltLt: number;
        statistic: number;

        // PolyJson type
        type: 'ttest_1samp';
    }

    export namespace TTest1SampResult {
        export const type = 'ttest_1samp';
    }

    /** @deprecated Use ComputationResult.isTTest1SampResult() */ export function isTTest1SampResult(toTest: ComputationResult): toTest is TTest1SampResult { return TTest1SampResult.type === toTest['type']; }
}